module.exports = __webpack_public_path__ + "img/redeem.af70d323.png";